export default {
    unauthorized: {
        title: 'Pristup odbijen',
        bodyBefore: 'Nemate opseg',
        bodyAfter: '. Obratite se svom administratoru za zahtjev za pristup.',
    },
}
